import React from "react";
import { useState } from "react";
import styles from "./FAQ.module.css";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "Czy sprzedajecie Państwo swoje opony?",
      answer:
        "Na tą chwilę nie sprzedajemy opon ani felg więc zapraszamy Państwa do nas z zakupionymi wcześniej oponami oraz felgami."
    },
    {
      question: "Czy można przyjechać nie zapisując się w kolejkę?",
      answer:
        "Oczywiście, zapraszamy do naszego warsztatu wtedy, kiedy macie Państwo czas. Zachęcamy jednak do wcześniejszego umówienia wizyty, ponieważ pierszeńswto mają osoby zapisane na daną godzinę. W związku z tym czas oczekiwania na usługę może się wydłużyć."
    },
    {
      question: "Czy można przyjechać do Pańswta poza sezonem ?",
      answer:
        "Oczywiście, zapraszamy Państwa każdego dnia. Wykonamy dla  przegląd opon w Pańswta aucie oraz inne ptrzebne działania."
    },
    {
      question:
        "Czy poza wysokim sezonem zimowym oraz letnim także należy umawiać wizytę.",
      answer:
        "Nie ma takiej potrzeby. Jednakże zawsze zchęcamy umówienie się na konkretną godzinę, aby mieli Państwo zagwarantowaną jak najlepszą obsługę."
    }
  ];

  const toggleFAQ = index => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="lightSectionContent" id="faq">
      <div className="darkSectionTitle">
        <h1>FAQ</h1>
      </div>
      <div className={styles.sectionDescription}>
        <div className={styles.faqContent}>
          {faqs.map((faq, index) =>
            <div
              key={index}
              className={`${styles.faqItem} ${activeIndex === index
                ? styles.active
                : ""}`}
            >
              <div
                className={styles.faqQuestion}
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
              </div>

              {activeIndex === index &&
                <div className={styles.faqAnswer}>
                  {faq.answer}
                </div>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
